module.exports = __webpack_public_path__ + "static/media/STABI M TURNTABLE.96a694b2.png";